<template>
    <div class="tool-panel-tabs">
        <div class="tab-bar">
            <button
                v-for="tab in tabs"
                :key="tab.key"
                class="tab-btn"
                :class="{ active: activeTab === tab.key }"
                @click="activeTab = tab.key"
            >
                {{ tab.label }}
            </button>
            <div class="tab-bar-actions">
                <slot name="actions" />
            </div>
        </div>
        <div class="tab-content">
            <template v-for="tab in tabs" :key="tab.key">
                <div v-show="activeTab === tab.key" class="tab-pane">
                    <slot :name="'tab-' + tab.key" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * Tab bar for ToolPanel content. Renders tabs from a { key, label } array.
 * Slots: #actions (right side of tab bar), #tab-{key} (content per tab).
 * Props: tabs (Array of { key: string, label: string }).
 */
export default {
    props: {
        tabs: { type: Array, required: true }
    },
    data() {
        return {
            activeTab: this.tabs[0]?.key ?? null
        }
    }
}
</script>

<style scoped>
.tool-panel-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tab-bar {
    display: flex;
    align-items: center;
    background: #f8f8f8;
    border-bottom: 1px solid #d9d9d9;
    flex-shrink: 0;
}

.tab-btn {
    padding: 0.55em 1.1em;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    color: #666;
    font-size: 0.88em;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.15s, border-color 0.15s;
    margin-bottom: -1px;
}

.tab-btn:hover { color: #333; }

.tab-btn.active {
    color: #333;
    border-bottom-color: #7FC000;
}

.tab-bar-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    padding-right: 0.8em;
    gap: 0.8em;
}

.tab-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tab-pane {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
</style>
